export default {
      id: "ico_close-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ico_close",
      toString: function () {
        return this.url;
      }
    }